/**
 * Accordion.
 * @param {string} selector Element class. 
 */
const sl_accordion = (selector) => {
	let accordions = document.querySelectorAll(selector);

	if (!accordions) return;

	accordions.forEach(accordion => {
		let items = accordion.querySelectorAll('.accordion-item');

		if (!items) return;

		items.forEach(item => {
			let cta = item.querySelector('.accordion-head')

			cta.addEventListener('click', (e) => {
				e.preventDefault();

				item.classList.toggle('opened')
			})
		});
	});
}

document.addEventListener("DOMContentLoaded", () => {
	sl_accordion('.sl-accordion');
});
